import React from 'react';
import { connect } from 'react-redux';
// GameGuide imports
import GuideStepStart from './GuideStepStart';
import GuideStepLoginWarning from './GuideStepLoginWarning';
import GuideStepGoalScore from './GuideStepGoalScore';
import GuideStepPlayer from './GuideStepPlayer';
import GuideStepLevel from './GuideStepLevel';
import GuideStepInfo from './GuideStepInfo';
// Game(kit) imports
import { GuideStepEnum } from '../../shared';
import MainNavigation from '../MainNavigation';
// Shared imports
import { redirectTo } from '../../../SharedUI/functions';

class GameGuide extends React.Component {
    HandleBack = () => {
        // Redirect to 'home' (REDIRECT BOOKMARK)
        redirectTo('');
    };

    getCurrentStep = () => {
        const { gameGuide } = this.props;
        const { currentStep } = gameGuide;

        switch (currentStep) {
            case GuideStepEnum.START: {
                return <GuideStepStart id="step-start" />;
            }
            case GuideStepEnum.LOGIN_WARNING: {
                return <GuideStepLoginWarning id="login-warning" />;
            }
            case GuideStepEnum.SPELER: {
                return <GuideStepPlayer id="step-player" />;
            }
            case GuideStepEnum.DOEL_SCORE: {
                return <GuideStepGoalScore id="step-goal-score" />;
            }
            case GuideStepEnum.LEVEL: {
                return <GuideStepLevel id="step-level" />;
            }
            case GuideStepEnum.INFO: {
                return <GuideStepInfo id="step-info" />;
            }
            default:
                // Do not display anything if state is inactive
                return <h1>Inactive</h1>;
        }
    };

    render() {
        const { loadedGamekit } = this.props;
        // Get current step
        const currentStep = this.getCurrentStep();

        return (
            <>
                <div id="game-guide-background">
                    <div className="background-top" />
                    <div className="background-bottom" />
                </div>
                <MainNavigation BtnBackText="HOME" BtnBackClass="gameguide-mainnav" BtnBackAlt="Terug naar hoofdpagina" OnBack={this.HandleBack} />
                {
                    loadedGamekit
                    ? (
                        <>
                            <div id="game-guide-container">{currentStep}</div>
                        </>
                    )
                    : <></>
                }
            </>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    gameGuide: state.gameGuide
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GameGuide);
